export default {
    'add-pharmaceutical-form': 'إضافة شكل دوائي',
    'edit-pharmaceutical-form': 'تعديل شكل دوائي',
    'the-pharmaceutical-form': 'الشكل الدوائي؟'
}